const CompanyAccess = {
  dashboard: ["zotrai", "trawtel", "babaair", "landairtravels", "landair"],
  visas: ["zotrai", "trawtel", "babaair", "landairtravels", "landair"],
  flights: ["zotrai", "trawtel", "babaair", "landairtravels", "landair"],
  hotels: ["zotrai", "trawtel", "babaair", "landairtravels", "landair"],
  packages: ["zotrai", "trawtel", "babaair", "landairtravels", "landair"],
  sightseeing: ["zotrai", "trawtel", "babaair", "landairtravels", "landair"],
  umrah: ["trawtel", "babaair"],
  hajj: ["trawtel", "babaair"],
  marketing: ["zotrai", "trawtel", "babaair", "landairtravels", "landair"],
  buses: ["zotrai", "trawtel"],
  accounts: ["zotrai", "trawtel"],
  seriesfare: ["zotrai", "trawtel"],
  dmcs: ["zotrai", "trawtel"],
  reports: ["zotrai", "trawtel"],
  website: ["zotrai", "trawtel"]


};
export default CompanyAccess;
